import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Texture = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages blurFeature">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:textureTitle1')}</h2>
          <p className="text">
            {t('contents:textureParagraph1')}
            <br />
            {t('contents:textureParagraph2')}
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/texture/texture_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <h2 className="title">{t('contents:textureTitle2')}</h2>
              <p>
                {t('contents:textureParagraph3')}
                <br />
                <br />
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/texture/texture_02.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:textureTitle3')}</h2>
              <p>{t('contents:textureParagraph4')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/texture/texture_03.png')} />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:textureTitle4')}</h2>
              <p>{t('contents:textureParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/texture/texture_04.png')} />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:textureTitle5')}</h2>
              <p>{t('contents:textureParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/texture/texture_05.png')} />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:textureTitle6')}</h2>
              <p>{t('contents:textureParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/texture/texture_06.png')} />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:textureTitle7')}</h2>
              <p>{t('contents:textureParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/texture/texture_07.png')} />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Texture;
